import { render, staticRenderFns } from "./PremiumPhotoExperience.vue?vue&type=template&id=96a1152e&scoped=true"
import script from "./PremiumPhotoExperience.vue?vue&type=script&lang=js"
export * from "./PremiumPhotoExperience.vue?vue&type=script&lang=js"
import style0 from "./PremiumPhotoExperience.vue?vue&type=style&index=0&id=96a1152e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a1152e",
  null
  
)

export default component.exports